var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("div", [
    _c(
      "label",
      {
        staticClass: "col-4",
      },
      [
        _c(
          "span",
          {
            staticClass: "required",
          },
          [
            _vm._v(
              "\n            " + _vm._s(_vm.$gettext("Hostname")) + "\n        "
            ),
          ]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.theHostname,
              expression: "theHostname",
            },
          ],
          attrs: {
            required: "",
            type: "text",
            name: "hostname",
            placeholder: "localhost",
          },
          domProps: {
            value: _vm.theHostname,
          },
          on: {
            input: function input($event) {
              if ($event.target.composing) return
              _vm.theHostname = $event.target.value
            },
          },
        }),
      ]
    ),
    _vm._v(" "),
    _c(
      "label",
      {
        staticClass: "col-2",
      },
      [
        _c(
          "span",
          {
            staticClass: "required",
          },
          [
            _vm._v(
              "\n            " + _vm._s(_vm.$gettext("Port")) + "\n        "
            ),
          ]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.thePort,
              expression: "thePort",
            },
          ],
          attrs: {
            required: "",
            type: "text",
            name: "port",
            placeholder: "6379",
          },
          domProps: {
            value: _vm.thePort,
          },
          on: {
            input: function input($event) {
              if ($event.target.composing) return
              _vm.thePort = $event.target.value
            },
          },
        }),
      ]
    ),
    _vm._v(" "),
    _c("label", [
      _vm._v(
        "\n        " +
          _vm._s(_vm.$gettext("Passwort/Token zur Authentifizierung")) +
          "\n        "
      ),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.theAuth,
            expression: "theAuth",
          },
        ],
        attrs: {
          type: "text",
          name: "auth",
        },
        domProps: {
          value: _vm.theAuth,
        },
        on: {
          input: function input($event) {
            if ($event.target.composing) return
            _vm.theAuth = $event.target.value
          },
        },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }